
import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForm = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      this.canvasForm
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/JGS_Logo.svg').attr('x', 20).attr('y', 20).attr('width', 230)

      this.canvasForm
      .append('text')
      .attr('id', 'SKY_TITLE')
      .attr('transform', `translate(20, 100)`)
      .attr('font-size', 20).attr('fill', '#000')
      .text(this.skyline.main)

      this.canvasForm
      .append('text')
      .attr('transform', `translate(20, 117)`)
      .attr('font-size', 12)
      .attr('fill', '#44A9DF')
      .text(this.skyline.sub)

      this.canvasForm
      .append('rect')
      .attr('x', -.5).attr('y', this.Canvas.CanvasHeight-10)
      .attr('width', this.Canvas.CanvasWidth).attr('height', 10)
      .attr('fill', '#44A9DF')

      this.summary_Overall(this.summarytData.find(f=> f.area == 'OVERALL'))

      this.summary.area.forEach(d=> {
        this.summary_Area(d, this.summarytData.find(f=> f.area == d.code))
      })
      

      this.draw_Timeline_Week()
      this.draw_SkylineCharts()
    if (this.search.visible == 'Y') this.draw_Search()
      this.draw_Legends()

      this.draw_Detail()
      // this.draw_Search()



      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


  }
}